/* eslint-disable max-len */
import React from 'react';
import { Typography, SkeletonLine } from '@one-thd/sui-atomic-components';
import { isInActive, formatDollar } from '../../utils/general';
import { defaultImage } from '../../utils/consts';

interface ICardBalanceProps {
  isLoading: boolean;
  balance?: number;
  imagePath?: string;
  onlineTransactable?: boolean;
  isLegacyCard?: boolean;
  isFailedLoadingBatch?: boolean;
}

const GiftCardBalance: React.FC<ICardBalanceProps> = ({
  isLoading,
  balance,
  onlineTransactable,
  isLegacyCard,
  imagePath,
  isFailedLoadingBatch
}): JSX.Element => {
  const isInActiveCard = isInActive(isLegacyCard, onlineTransactable);
  const showLoader = isLoading && typeof balance !== 'number' && !isFailedLoadingBatch;

  if (showLoader && !isLegacyCard) {
    return (
      <div className="sui-w-full" data-testid="balance-loader">
        <SkeletonLine variant="multi" numberOfLines={2} />
      </div>
    );
  }

  return (
    <div className="sui-grid sui-grid-cols-2 sui-w-full sui-items-center sui-gap-4">
      <img
        className={`sui-rounded-md ${isInActiveCard || isLegacyCard ? 'sui-opacity-50' : ''}`}
        src={imagePath || defaultImage}
        alt="Placeholder img"
        height="90"
        width="160"
        data-testid="gift-card-image"
      />
      {!isLegacyCard && typeof balance === 'number' && (
        <Typography
          variant="h3"
          weight="bold"
          data-testid="gift-card-balance"
          color={isInActiveCard ? 'inactive' : 'primary'}
        >
          {formatDollar(balance || 0)}
        </Typography>
      )}
    </div>
  );
};

export { GiftCardBalance };
